var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: "mdi-group",
      show: _vm.dialog,
      maxWidth: "40%",
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            autofocus: "",
                            error: !!_vm.errors.name,
                            "error-messages": _vm.errors.name,
                            label: "Nome*",
                          },
                          model: {
                            value: _vm.model.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "name", $$v)
                            },
                            expression: "model.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            error: !!_vm.errors.initials,
                            "error-messages": _vm.errors.initials,
                            label: "Sigla*",
                          },
                          model: {
                            value: _vm.model.initials,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "initials", $$v)
                            },
                            expression: "model.initials",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-text-field", {
                          attrs: {
                            code: "",
                            "error-messages": _vm.errors.code,
                            label: "Código",
                          },
                          model: {
                            value: _vm.model.code,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "code", $$v)
                            },
                            expression: "model.code",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            inset: "",
                            "text-helper": "Categoria Padrão para novas turmas",
                            label: "Padrão",
                          },
                          model: {
                            value: _vm.model.default,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "default", $$v)
                            },
                            expression: "model.default",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            inset: "",
                            "text-helper":
                              "Permitir edição de oferta na tela de Professores das Turmas",
                            label: "Permitir Edição",
                          },
                          model: {
                            value: _vm.model.allow_editing_grids,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "allow_editing_grids", $$v)
                            },
                            expression: "model.allow_editing_grids",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            inset: "",
                            "text-helper":
                              "Bloquear alterações na tela de horário",
                            label: "Bloquear Horário",
                          },
                          model: {
                            value: _vm.model.time_table_locked,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "time_table_locked", $$v)
                            },
                            expression: "model.time_table_locked",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            inset: "",
                            "text-helper":
                              "Permitir carga horária paga da grade maior que a carga horária original",
                            label: "Permitir CH Paga maior",
                          },
                          model: {
                            value: _vm.model.allow_overflow_work_load,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.model,
                                "allow_overflow_work_load",
                                $$v
                              )
                            },
                            expression: "model.allow_overflow_work_load",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.acesso &&
                _vm.acesso.periodo &&
                _vm.acesso.periodo.attribution_work_time_dates
                  ? _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "6" } },
                          [
                            _c("s-text-field", {
                              attrs: {
                                cleareable: "",
                                "text-helper":
                                  "Carga Horária base para atribuição de professor",
                                "error-messages":
                                  _vm.errors.attribution_work_load_pay,
                                label: "CH Atribuição",
                              },
                              model: {
                                value: _vm.model.attribution_work_load_pay,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.model,
                                    "attribution_work_load_pay",
                                    $$v
                                  )
                                },
                                expression: "model.attribution_work_load_pay",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }